import { QualityScore } from '../Quality';
// Temporary placeholder until pre-flight check completed to prevent errors.
import { PreflightTestReport } from '../../../AppStateProvider/AppStateProvider';
import { round } from '../../../../utils';

export function getSingleQualityScore(
  stat: number | undefined,
  goodThreshold: number,
  suboptimalThreshold: number,
  poorThreshold: number,
  descending: boolean = false
) {
  if (typeof stat === 'undefined') {
    // We ignore values that are missing
    return QualityScore.Excellent;
  }

  if (descending) {
    if (stat > goodThreshold) return QualityScore.Excellent;
    if (stat > suboptimalThreshold) return QualityScore.Good;
    if (stat > poorThreshold) return QualityScore.Suboptimal;
    return QualityScore.Poor;
  }

  if (stat >= poorThreshold) return QualityScore.Poor;
  if (stat >= suboptimalThreshold) return QualityScore.Suboptimal;
  if (stat >= goodThreshold) return QualityScore.Good;
  return QualityScore.Excellent;
}

export const formatNumber = (val: number | undefined) => {
  return val?.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export function getQualityScore(preflightTestReport: PreflightTestReport | null) {
  const latency = {
    average: formatNumber(preflightTestReport?.stats!.rtt!.average),
    qualityScore: getSingleQualityScore(preflightTestReport?.stats!.rtt!.average, 100, 250, 400),
  };

  const jitter = {
    average: formatNumber(preflightTestReport?.stats!.jitter!.average),
    qualityScore: getSingleQualityScore(preflightTestReport?.stats!.jitter!.average, 5, 10, 30),
  };

  const packetLoss = {
    average: round((preflightTestReport?.totals?.packetsLostFraction ?? 0) * 100),
    qualityScore: getSingleQualityScore(
      preflightTestReport?.totals?.packetsLostFraction === undefined
        ? undefined
        : preflightTestReport.totals.packetsLostFraction * 100,
      1,
      3,
      8
    ),
  };

  return {
    latency,
    jitter,
    packetLoss,
  };
}
